(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-cart-popup"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-cart-popup')) {
		class LTACartPopup extends LTADrawer {
			static STORAGE = {
				PDP_VISITED: 'cartPopupPdpVisited',
				DISMISSED: 'cartPopupDismissed',
			}

			constructor() {
				super()
				this.handleUrlChange = this.handleUrlChange.bind(this)
				this.handleOutsideClick = this.handleOutsideClick.bind(this)
				this.handleOutsideEscape = this.handleOutsideEscape.bind(this)
			}

			static isPdpPath(pathname = window.location.pathname) {
				return pathname.includes('/products/')
			}

			static markPdpVisited() {
				sessionStorage.setItem(LTACartPopup.STORAGE.PDP_VISITED, '1')
			}

			static hasPdpVisited() {
				return sessionStorage.getItem(LTACartPopup.STORAGE.PDP_VISITED) === '1'
			}

			static isDismissed() {
				return sessionStorage.getItem(LTACartPopup.STORAGE.DISMISSED) === '1'
			}

			static markDismissed() {
				sessionStorage.setItem(LTACartPopup.STORAGE.DISMISSED, '1')
			}

			static waitForReturningCustomerStatus() {
				return new Promise((resolve) => {
					if (typeof window.isReturningCustomer === 'boolean') {
						resolve(window.isReturningCustomer)
						return
					}

					document.addEventListener(
						'l:hasVisitedBefore',
						(event) => {
							resolve(!!event.detail?.isReturningCustomer)
						},
						{ once: true }
					)
				})
			}

			static getActiveVersion() {
				if (window.WCCartPopupV1) return 'v1'

				return 'control'
			}

			shouldTrackEvent(version) {
				const flags = {
					control: window.WCCartPopupControl,
					v1: window.WCCartPopupV1,
				}
				const flag = flags[version]

				return typeof flag === 'undefined' || flag === '' || flag
			}

			trackCartPopupOpened(version = LTACartPopup.getActiveVersion()) {
				if (!this.shouldTrackEvent(version)) return

				l_intelligenceEvents(`Cart Popup ${version} - Opened`)
			}

			trackCartPopupCtaClicked() {
				if (!this.shouldTrackEvent('v1')) return

				l_intelligenceEvents('Cart Popup v1 - CTA Clicked')
			}

			connectedCallback() {
				super.connectedCallback()
				this.setupCartDrawerCta()
				this.initCartPopupTrigger()
			}

			setupCartDrawerCta() {
				const cartDrawerCtaEl = this.querySelector('[data-open-cart-drawer]')

				if (!cartDrawerCtaEl) return

				cartDrawerCtaEl.addEventListener('click', () => {
					this.trackCartPopupCtaClicked()

					const cartDrawerEl = document.querySelector('cart-drawer')

					this.drawer_close()

					if (cartDrawerEl) {
						cartDrawerEl.open(cartDrawerCtaEl)
					}
				})
			}

			disconnectedCallback() {
				window.removeEventListener('popstate', this.handleUrlChange)
			}

			hasCartItems() {
				return parseInt(this.dataset.cartItemCount, 10) > 0
			}

			handleUrlChange() {
				if (LTACartPopup.isPdpPath()) {
					LTACartPopup.markPdpVisited()
				}
			}

			async initCartPopupTrigger() {
				if (typeof Shopify !== 'undefined' && Shopify.designMode) return
				if (window.ACartPopupTriggered !== true) return
				if (LTACartPopup.isDismissed()) return

				if (LTACartPopup.isPdpPath()) {
					LTACartPopup.markPdpVisited()
					return
				}

				if (!this.hasCartItems()) return

				window.addEventListener('popstate', this.handleUrlChange)

				const isReturningCustomer = await LTACartPopup.waitForReturningCustomerStatus()

				if (!isReturningCustomer) return
				if (LTACartPopup.hasPdpVisited()) return
				if (LTACartPopup.isDismissed()) return
				if (this.classList.contains('is-active')) return
				if (window.ACartPopupTriggered !== true) return

				const version = LTACartPopup.getActiveVersion()

				if (version === 'control') {
					this.trackCartPopupOpened('control')
					return
				}

				this.drawer_open()
				this.trackCartPopupOpened('v1')
			}

			drawer_open(triggerEl) {
				this.setupAOS('remove')
				l_setupVariablesBeforeOpenModal()

				this.classList.remove('l-hidden')

				requestAnimationFrame(() => {
					this.classList.add('is-active')
				})

				if (triggerEl) {
					this.triggerEl = triggerEl
				}

				l_trapFocus({ container: this.drawerInnerEl })
				this.setupAOS('add')

				window.addEventListener('click', this.handleOutsideClick)
				window.addEventListener('keyup', this.handleOutsideEscape)

				document.dispatchEvent(
					new CustomEvent('l:drawer:open', {
						detail: { drawerName: this.drawerName },
					})
				)
			}

			handleOutsideClick(event) {
				this.drawer_closeOutsideOnClick(event)
			}

			handleOutsideEscape(event) {
				this.drawer_closeOutsideOnEscape(event)
			}

			drawer_close() {
				LTACartPopup.markDismissed()

				this.classList.remove('is-active')

				window.l_debounce(() => {
					this.classList.add('l-hidden')
				}, 400)()

				if (this.triggerEl) {
					l_removeTrapFocus(this.triggerEl)
					this.triggerEl = null
				}

				window.removeEventListener('click', this.handleOutsideClick)
				window.removeEventListener('keyup', this.handleOutsideEscape)
			}
		}

		customElements.define('l-cart-popup', LTACartPopup)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-quiz-popups"] && !Shopify.designMode) return;
  try {
    
	const QUIZ_POPUP_DELAY_MS = 120 * 1000
	const QUIZ_POPUP_STORAGE = {
		PDP_VISITED: 'quizPopupPdpVisited',
		DISMISSED: 'quizPopupV1Dismissed',
	}

	function l_isQuizPopupPdpPath(pathname = window.location.pathname) {
		return pathname.includes('/products/')
	}

	function l_markQuizPopupPdpVisited() {
		sessionStorage.setItem(QUIZ_POPUP_STORAGE.PDP_VISITED, '1')
	}

	function l_hasQuizPopupPdpVisited() {
		return sessionStorage.getItem(QUIZ_POPUP_STORAGE.PDP_VISITED) === '1'
	}

	function l_isQuizPopupDismissed() {
		return sessionStorage.getItem(QUIZ_POPUP_STORAGE.DISMISSED) === '1'
	}

	function l_markQuizPopupDismissed() {
		sessionStorage.setItem(QUIZ_POPUP_STORAGE.DISMISSED, '1')
	}

	function l_getSessionElapsedMs() {
		const sessionStarted = parseInt(sessionStorage.getItem('sessionStarted'), 10)

		if (!sessionStarted) return 0

		return Date.now() - sessionStarted
	}

	if (!customElements.get('l-quiz-popup-drawer')) {
		class LTAQuizPopupDrawer extends LTADrawer {
			constructor() {
				super()
				this.handleUrlChange = this.handleUrlChange.bind(this)
			}

			connectedCallback() {
				super.connectedCallback()
				this.initQuizPopupTrigger()
			}

			disconnectedCallback() {
				this.clearQuizPopupTimers()
				window.removeEventListener('popstate', this.handleUrlChange)
			}

			clearQuizPopupTimers() {
				if (this.quizPopupTimeoutId) {
					clearTimeout(this.quizPopupTimeoutId)
					this.quizPopupTimeoutId = null
				}

				if (this.quizPopupPollId) {
					clearInterval(this.quizPopupPollId)
					this.quizPopupPollId = null
				}
			}

			handleUrlChange() {
				if (l_isQuizPopupPdpPath()) {
					l_markQuizPopupPdpVisited()
					this.clearQuizPopupTimers()
				}
			}

			trackQuizPopupOpened() {
				const version = this.dataset.version
				const flags = {
					control: window.WCQuizPopupControl,
					v1: window.WCQuizPopupV1,
					v2: window.WCQuizPopupV2,
				}
				const flag = flags[version]

				if (typeof flag === 'undefined' || flag === '' || flag) {
					l_intelligenceEvents(`Quiz Popup ${version} - Opened`)
				}
			}

			async initQuizPopupTrigger() {
				const isDesignMode = typeof Shopify !== 'undefined' && Shopify.designMode
				const isDismissed = l_isQuizPopupDismissed()
				const isPdpPath = l_isQuizPopupPdpPath()

				if (isDesignMode) return
				if (window.AQuizPopupsTriggered !== true) return
				if (isDismissed) return
				if (isPdpPath) {
					l_markQuizPopupPdpVisited()
					return
				}

				window.addEventListener('popstate', this.handleUrlChange)

				const hasPdpVisited = l_hasQuizPopupPdpVisited()
				const isDismissedAgain = l_isQuizPopupDismissed()

				if (hasPdpVisited || isDismissedAgain) return

				this.quizPopupPollId = setInterval(() => {
					const pdpPathCheck = l_isQuizPopupPdpPath()

					if (pdpPathCheck) {
						l_markQuizPopupPdpVisited()
						this.clearQuizPopupTimers()
					}
				}, 1000)

				const remainingMs = Math.max(QUIZ_POPUP_DELAY_MS - l_getSessionElapsedMs(), 0)

				this.quizPopupTimeoutId = setTimeout(() => {
					this.clearQuizPopupTimers()

					const hasVisited = l_hasQuizPopupPdpVisited()
					const isDismissedNow = l_isQuizPopupDismissed()
					const isReturning = window.isReturningCustomer
					const isActive = this.classList.contains('is-active')

					if (hasVisited || isDismissedNow) return
					if (isReturning) return
					if (isActive) return
					if (window.AQuizPopupsTriggered !== true) return

					this.drawer_open()
					this.trackQuizPopupOpened()
				}, remainingMs)
			}

			drawer_open(triggerEl) {
				this.setupAOS('remove')
				l_setupVariablesBeforeOpenModal()

				this.classList.remove('l-hidden')

				requestAnimationFrame(() => {
					this.classList.add('is-active')
				})

				if (triggerEl) {
					this.triggerEl = triggerEl
				}

				l_trapFocus({ container: this.drawerInnerEl })
				this.setupAOS('add')

				window.addEventListener('click', this.drawer_closeOutsideOnClick.bind(this))
				window.addEventListener('keyup', this.drawer_closeOutsideOnEscape.bind(this))

				document.dispatchEvent(
					new CustomEvent('l:drawer:open', {
						detail: { drawerName: this.drawerName },
					})
				)
			}

			drawer_close() {
				l_markQuizPopupDismissed()

				this.classList.remove('is-active')

				window.l_debounce(() => {
					this.classList.add('l-hidden')
				}, 400)()

				if (this.triggerEl) {
					l_removeTrapFocus(this.triggerEl)
					this.triggerEl = null
				}

				window.removeEventListener('click', this.drawer_closeOutsideOnClick)
				window.removeEventListener('keyup', this.drawer_closeOutsideOnEscape)
			}
		}

		customElements.define('l-quiz-popup-drawer', LTAQuizPopupDrawer)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-welcome-back-popup"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-welcome-back-popup')) {
		class LTAWelcomeBackPopup extends LTADrawer {
			static DELAY_MS = 100
			static COOKIE_DAYS = 30
			static COOKIES = {
				PDP_VIEWED: 'PDP_Viewed',
				ADDED_TO_CART: 'Added_ToCart',
			}
			static STORAGE = {
				DISMISSED: 'welcomeBackPopupDismissed',
			}
			static SELECTORS = {
				PRODUCT_TITLE: '[data-wbbp-product-title]',
				DRAWER_INNER: '[data-wbbp-drawer-inner]',
				POPUP_WITH_HANDLE: 'l-welcome-back-popup[data-product-handle]',
			}
			static globalTrackingInitialized = false

			static getCookie(name) {
				const match = document.cookie.match(
					new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)')
				)

				return match ? decodeURIComponent(match[1]) : null
			}

			static setCookie(name, value, days = LTAWelcomeBackPopup.COOKIE_DAYS) {
				const expires = new Date(Date.now() + days * 864e5).toUTCString()

				document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`
			}

			static clearCookie(name) {
				document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`
			}

			static isHomepage(pathname = window.location.pathname) {
				return pathname === '/' || /^\/[a-z]{2}(-[a-z]{2})?\/?$/.test(pathname)
			}

			static isPdpPath(pathname = window.location.pathname) {
				return pathname.includes('/products/')
			}

			static getProductHandleFromPath(pathname = window.location.pathname) {
				const match = pathname.match(/\/products\/([^/?#]+)/)

				return match ? decodeURIComponent(match[1]) : null
			}

			static markPdpViewed(handle) {
				if (!handle) return

				LTAWelcomeBackPopup.setCookie(LTAWelcomeBackPopup.COOKIES.PDP_VIEWED, handle)
				LTAWelcomeBackPopup.clearCookie(LTAWelcomeBackPopup.COOKIES.ADDED_TO_CART)
			}

			static getPdpViewedHandle() {
				return LTAWelcomeBackPopup.getCookie(LTAWelcomeBackPopup.COOKIES.PDP_VIEWED)
			}

			static hasPdpViewed() {
				return !!LTAWelcomeBackPopup.getPdpViewedHandle()
			}

			static markAddedToCart() {
				LTAWelcomeBackPopup.setCookie(LTAWelcomeBackPopup.COOKIES.ADDED_TO_CART, '1')
			}

			static hasAddedToCart() {
				return LTAWelcomeBackPopup.getCookie(LTAWelcomeBackPopup.COOKIES.ADDED_TO_CART) === '1'
			}

			static isDismissed() {
				return sessionStorage.getItem(LTAWelcomeBackPopup.STORAGE.DISMISSED) === '1'
			}

			static markDismissed() {
				sessionStorage.setItem(LTAWelcomeBackPopup.STORAGE.DISMISSED, '1')
			}

			static waitForReturningCustomerStatus() {
				return new Promise((resolve) => {
					if (typeof window.isReturningCustomer === 'boolean') {
						resolve(window.isReturningCustomer)
						return
					}

					document.addEventListener(
						'l:hasVisitedBefore',
						(event) => {
							resolve(!!event.detail?.isReturningCustomer)
						},
						{ once: true }
					)
				})
			}

			static getSectionDrawerInnerHtml(sectionHtml, popupId) {
				const sectionDoc = new DOMParser().parseFromString(sectionHtml, 'text/html')
				const fetchedPopupEl = sectionDoc.getElementById(popupId)
				const fetchedDrawerInnerEl = fetchedPopupEl?.querySelector(LTAWelcomeBackPopup.SELECTORS.DRAWER_INNER)

				return fetchedDrawerInnerEl?.innerHTML || null
			}

			static async fetchSectionHtml(handle, sectionId) {
				const root = window.Shopify?.routes?.root || '/'
				const url = `${root}products/${handle}?sections=${encodeURIComponent(sectionId)}`
				const response = await fetch(url)

				if (!response.ok) return null

				const sections = await response.json()

				return sections[sectionId] || null
			}

			static initGlobalTracking() {
				if (LTAWelcomeBackPopup.globalTrackingInitialized) return
				if (typeof Shopify !== 'undefined' && Shopify.designMode) return

				LTAWelcomeBackPopup.globalTrackingInitialized = true

				if (LTAWelcomeBackPopup.isPdpPath()) {
					const welcomeBackPopupEl = document.querySelector(LTAWelcomeBackPopup.SELECTORS.POPUP_WITH_HANDLE)
					const handle = welcomeBackPopupEl?.dataset.productHandle || LTAWelcomeBackPopup.getProductHandleFromPath()

					LTAWelcomeBackPopup.markPdpViewed(handle)
				}

				document.addEventListener('l:product:added', LTAWelcomeBackPopup.markAddedToCart)
			}

			connectedCallback() {
				super.connectedCallback()
				LTAWelcomeBackPopup.initGlobalTracking()
				this.initWelcomeBackPopupTrigger()
			}

			disconnectedCallback() {
				this.clearWelcomeBackPopupTimer()
			}

			clearWelcomeBackPopupTimer() {
				if (this.welcomeBackPopupTimeoutId) {
					clearTimeout(this.welcomeBackPopupTimeoutId)
					this.welcomeBackPopupTimeoutId = null
				}
			}

			refreshCloseButtons() {
				this.closeBtnEls = this.querySelectorAll('[data-close]')

				this.closeBtnEls.forEach((closeBtnEl) => {
					closeBtnEl.addEventListener('click', () => {
						this.drawer_close()
					})
				})
			}

			async populateProduct(handle) {
				if (!handle) return false

				const drawerInnerEl = this.querySelector(LTAWelcomeBackPopup.SELECTORS.DRAWER_INNER)
				const productTitleEl = drawerInnerEl?.querySelector(LTAWelcomeBackPopup.SELECTORS.PRODUCT_TITLE)
				const hasProductContent = productTitleEl?.textContent?.trim()

				if (hasProductContent) return true

				const sectionId = this.dataset.sectionId

				if (!sectionId || !drawerInnerEl) return false

				const sectionHtml = await LTAWelcomeBackPopup.fetchSectionHtml(handle, sectionId)

				if (!sectionHtml) return false

				const drawerInnerHtml = LTAWelcomeBackPopup.getSectionDrawerInnerHtml(sectionHtml, this.id)

				if (!drawerInnerHtml) return false

				drawerInnerEl.innerHTML = drawerInnerHtml

				return true
			}

			async initWelcomeBackPopupTrigger() {
				if (typeof Shopify !== 'undefined' && Shopify.designMode) return
				if (window.AWelcomeBackPopupTriggered !== true) return
				if (LTAWelcomeBackPopup.isDismissed()) return
				if (!LTAWelcomeBackPopup.isHomepage()) return
				if (!LTAWelcomeBackPopup.hasPdpViewed()) return
				if (LTAWelcomeBackPopup.hasAddedToCart()) return

				const isReturningCustomer = await LTAWelcomeBackPopup.waitForReturningCustomerStatus()
				if (!isReturningCustomer) return

				const handle = LTAWelcomeBackPopup.getPdpViewedHandle()
				const isPopulated = await this.populateProduct(handle)

				if (!isPopulated) return

				if (isPopulated) {
					this.refreshCloseButtons()
				}

				if (this.classList.contains('is-active')) return

				this.clearWelcomeBackPopupTimer()

				this.welcomeBackPopupTimeoutId = setTimeout(() => {
					this.welcomeBackPopupTimeoutId = null

					if (LTAWelcomeBackPopup.isDismissed()) return
					if (!LTAWelcomeBackPopup.isHomepage()) return
					if (!LTAWelcomeBackPopup.hasPdpViewed()) return
					if (LTAWelcomeBackPopup.hasAddedToCart()) return
					if (!window.isReturningCustomer) return
					if (this.classList.contains('is-active')) return
					if (window.AWelcomeBackPopupTriggered !== true) return

					this.drawer_open()

					// Track welcome back popup open event if the feature flag is enabled or unset
					const version = this.dataset.version
					const flags = {
						control: window.WCBackPopupControl,
						v1: window.WCBackPopupV1,
						v2: window.WCBackPopupV2,
					}
					const flag = flags[version]
					if (typeof flag === 'undefined' || flag === '' || flag) {
						l_intelligenceEvents(`Welcome Back Popup ${version} - Opened`)
					}
				}, LTAWelcomeBackPopup.DELAY_MS)
			}

			drawer_open(triggerEl) {
				this.setupAOS('remove')
				l_setupVariablesBeforeOpenModal()

				this.classList.remove('l-hidden')

				requestAnimationFrame(() => {
					this.classList.add('is-active')
				})

				if (triggerEl) {
					this.triggerEl = triggerEl
				}

				l_trapFocus({ container: this.drawerInnerEl })
				this.setupAOS('add')

				window.addEventListener('click', this.drawer_closeOutsideOnClick.bind(this))
				window.addEventListener('keyup', this.drawer_closeOutsideOnEscape.bind(this))

				document.dispatchEvent(
					new CustomEvent('l:drawer:open', {
						detail: { drawerName: this.drawerName },
					})
				)
			}

			drawer_close() {
				LTAWelcomeBackPopup.markDismissed()
				this.clearWelcomeBackPopupTimer()

				this.classList.remove('is-active')

				window.l_debounce(() => {
					this.classList.add('l-hidden')
				}, 400)()

				if (this.triggerEl) {
					l_removeTrapFocus(this.triggerEl)
					this.triggerEl = null
				}

				window.removeEventListener('click', this.drawer_closeOutsideOnClick)
				window.removeEventListener('keyup', this.drawer_closeOutsideOnEscape)
			}

			drawer_closeOutsideOnClick() {
				// Disable the close event if the click is outside the drawer
			}
			drawer_closeOutsideOnEscape() {
				// Disable the close event if the escape key is pressed
			}
		}

		customElements.define('l-welcome-back-popup', LTAWelcomeBackPopup)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const customHeaderWrapper = document.querySelector('.custom-header--wrapper');
    const headerLogoOpener = customHeaderWrapper.querySelector('.header__heading-link');
    if (customHeaderWrapper) {
      const headerMenus = customHeaderWrapper.querySelectorAll('.header__menu-item');
      headerMenus.forEach((headerMenu) => {
        headerMenu.addEventListener('click', (e) => {
          headerMenus.forEach((menu) => {
            menu.classList.add('text-color-secondary');
          });
          e.currentTarget.classList.remove('text-color-secondary');

          if (window.innerWidth < 989) {
            headerLogoOpener.parentElement.querySelector('.header__inline-menu').classList.remove('menu-opened');
          }
        });
      });
    }

    const openMobileMenu = () => {
      if (headerLogoOpener && window.innerWidth < 989) {
        headerLogoOpener.addEventListener('click', (e) => {
          e.preventDefault();
          e.currentTarget.parentElement.querySelector('.header__inline-menu').classList.toggle('menu-opened');
        });
      }
    };

    openMobileMenu();
    window.addEventListener('resize', openMobileMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
